import React from 'react';
import './style.scss';
import './themed.scss';
const Loading = () => <p className="loading-spinner" aria-live="assertive">Loading<span>.</span><span>.</span><span>.</span></p>
export default Loading